import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M18.326 9.086h-3.585l.704-2.115a3.183 3.183 0 0 0-1.25-3.643 1.997 1.997 0 0 0-2.727.514L7.64 9.31a.81.81 0 0 0-.559-.224H3.816A.816.816 0 0 0 3 9.902v9.792a.816.816 0 0 0 .816.816H7.08a.816.816 0 0 0 .816-.816v-.108l1.18.787a.82.82 0 0 0 .452.137h7.344a.816.816 0 0 0 .73-.451l2.985-5.97c.24-.481.364-1.01.365-1.546v-.831a2.629 2.629 0 0 0-2.626-2.626ZM6.264 18.878H4.632v-8.16h1.632v8.16Zm13.056-6.335c0 .283-.067.562-.193.816l-2.76 5.519H9.774l-1.877-1.253v-5.834l4.91-7.013a.35.35 0 0 1 .484-.092 1.545 1.545 0 0 1 .607 1.77l-1.061 3.188a.817.817 0 0 0 .772 1.074h4.718a.994.994 0 0 1 .994.994v.83Z"
    />
  </svg>
);
export default SvgLike;
